import React from 'react';
import CorePage from './CorePage';
import UserStore from '../../util/UserStore';
import HmEventRegistry from '../../model/HmEventRegistry';
import HawkEye from '../../util/HawkEye';
import AttributeManager from '../../util/AttributeManager';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import BrowserUtil from '../../util/BrowserUtil';
import SubscribeButton from '../../views/common/SubscribeButton';
import NativeAjax from '../../util/NativeAjax';

export default class LoggedInPage extends CorePage{
	constructor(props) {
		super(props);
		this.state = {loggedIn:false,LumosloggedIn:false};

		this.UserStore = new UserStore();
		var UserObj = this.UserStore.get();
		
		this.plpTrackKey = "PLP_TRACK";

		if(!UserObj){
			//try to reload the page then prompt if the user is not logged in
			this.sessionCheck(() => {window.location.reload();}, () => {HmEventRegistry.fireEvent("LOG_OUT_PROMPT");})
		}else{
			this.attributeManager = new AttributeManager(this.UserStore);	
			HmEventRegistry.fireEvent("SET_TRACK_STORE",this.UserStore);
		}
		
		
	}
	componentDidMount(){
		//Freshchat is not required in LoggedInPages
		//this.initiateFreshChat();
	}

	getCmpHelper(){
		return super.getCmpHelper(this.UserStore);
	}

	getComponent(cmpName){
		return this.getCmpHelper().getCmp(cmpName);
	}

	getGeo(){
	    return (this.getUser().getLoginId()) ? this.getUser().getGeo(): super.getGeo();
	}

	subscribeFn(dataga){
		return (
			<SubscribeButton ga={dataga}></SubscribeButton>
			);
		}

		fireMobileToast(){
			if(this.isMobile() || this.isTab()){
				var mode = 0;
				try{
					if(this.UserStore && this.UserStore.getAuthProviderId()){
						if(mode === 4){
							mode = this.getUser().getAuthProviderId();
						}
					}
				}catch(e){}
				this.fireEvent("DESKTOP_EXP_TOAST",{msg:"warn_desktop_experience_"+mode,level:"warn"});
			}
		}

		setAttribute(attrKey, attrValue, callBack){
			let oldAttrVal = this.getAttribute(attrKey);

			if(oldAttrVal === attrValue){
				if(callBack && typeof callBack === "function"){
					callBack.apply(this);
				}
			}else{
				//console.log("lala::: set attribute::",attrKey,typeof attrValue);
				this.attributeManager.update(attrKey, attrValue, callBack);	
			}	
		}

		removeAttribute(attrKey, callBack){
			this.attributeManager.remove(attrKey, callBack);	
		}

		getAttribute(attrKey){
		//console.log("lala::: get attribute "," : ",this.UserStore.getAttribute(attrKey));
		return this.UserStore.getAttribute(attrKey);
		}

LumosSessionCheck(){	

	var me = this;
	var user_Success = function(userObj){	
		if(typeof userObj === "object" && userObj.sessionValid){
			me.setState({LumosloggedIn:true});			

			let lumosRedirect = true;

			if(window.lumos_allowed_routes && window.lumos_allowed_routes.length > 0){
				for(var i=0;i<window.lumos_allowed_routes.length;i++){
					if(window.location.href && window.location.href.match(window.lumos_allowed_routes[i])){
						lumosRedirect = false;
						break;
					}
				}
			}


				/*if(window.lumos_restricted_routes && window.lumos_restricted_routes.length > 0){
					for(var i=0;i<window.lumos_restricted_routes.length;i++){
						if(window.location.href && window.location.href.match(window.lumos_restricted_routes[i])){
							lumosRedirect = true;
							break;
						}
					}
				}*/

				if(lumosRedirect){
					//For a Lumos User, always redirect him to Lumos Page
					window.location.href = me.getUrlFor("LUMOS_REDIRECT_URL");		
				}
			}else{
				me.setState({LumosloggedIn:false});
			}
		}

		var user_Failure = function(error){
			me.setState({LumosloggedIn:false});

		}		
		new NativeAjax(this.getUrlFor("LUMOS_SESSION_CHECK")).enableCORS().get(user_Success,user_Failure);		
	}

	sessionCheck(sessionValid, sessionInvalid, forceTrigger=true){
		var me = this;
		var success = function(userObj){
			if(typeof userObj === "object" && userObj.authToken){
				//Update the userStore Object
				me.UserStore.set(userObj);
				//Updating the locale for the user
				me.setLocale(me.UserStore.getLocale());

				me.setState({loggedIn:true});
				me.attributeManager = new AttributeManager(me.UserStore);
				me.trackPending();
				
				//Lumos User Session Check
				HmEventRegistry.fireEvent("SCHEDULE_LUMOS_HEARTBEAT");


				//Appending user params to FreshChat
				HmEventRegistry.fireEvent("ADD_USER_FRESHCHAT", me.UserStore);

				//Check if callbackUser session is valid 
				if(typeof sessionValid === "function"){
					sessionValid.apply(this, [userObj]);
				}

			}else{
				//Clear userStore
				me.UserStore.clearOldUser();
				me.trackPending();

				//Clear FreshChat user
				HmEventRegistry.fireEvent("CLEAR_USER_FRESHCHAT");

				//User session is no longer valid
				if(typeof sessionInvalid === "function"){
					sessionInvalid.apply(this, [userObj]);
				}
				else{
					//Handle auto-redirection to prelogin page
					if(typeof userObj === "object" && Object.keys(userObj).length > 0){
						if(typeof userObj.sessionValid !== "undefined" && userObj.sessionValid === "false"){
							HmEventRegistry.fireEvent("LOG_OUT_PROMPT");
						}
					}
				}
			}
		}

		var failure = function(error){

			//Clear FreshChat user
			HmEventRegistry.fireEvent("CLEAR_USER_FRESHCHAT");

			//User session is no longer valid
			if(typeof sessionInvalid === "function"){
				sessionInvalid.apply(this, [error]);
			}
			else{
				//Handle auto-redirection to prelogin page
				if(typeof error === "object" && Object.keys(error).length > 0){
					if(typeof error.sessionValid !== "undefined" && error.sessionValid === "false"){
						HmEventRegistry.fireEvent("LOG_OUT_PROMPT");
					}
				}
			}
		}

		super.sessionCheck(success,failure, forceTrigger);
	}

	trackPending(){
		try{
			var plpTrackEvents = JSON.parse(BrowserStorageUtil.getStoredSessionItem(this.plpTrackKey));
			//console.log("loginInfo:::",loginInfo);
			var length = plpTrackEvents.length;
			if(plpTrackEvents){
				for(var i = 0; i < length; i++) {
					var trackEvent = plpTrackEvents.pop(); 
					this.initiateTrack(trackEvent.name,trackEvent.data);
					BrowserStorageUtil.storeSessionItem(this.plpTrackKey, JSON.stringify(plpTrackEvents))
				}
			}
		}catch(e){}
	}
	
	storeTrackEvent(name, data) {
		var events = JSON.parse(BrowserStorageUtil.getStoredSessionItem(this.plpTrackKey));
		events.push({name: name, data: data});
		BrowserStorageUtil.storeSessionItem(this.plpTrackKey, JSON.stringify(events));
	}
	
	initiateTrack(trackKey, addnldata){
		try{
			var eventObj = this.getTracker();
			
			var trackObj = eventObj.getEventObject(eventObj.eventCodes[trackKey]);

			trackObj.event_details.user_id = this.getUser().getUserId() || "";
			trackObj.event_details.session_id = this.getUser().getAuthToken() || "";
			trackObj.event_details.timestamp = new Date().getTime() || "";
			
			console.log("addnldata:::",addnldata);
			console.log(trackObj.event_data);
			if(addnldata !== undefined && typeof addnldata === "object"){
				for(var key in addnldata){
					trackObj.event_data[key] = addnldata[key];
				}
			}
			
			var output = {"event":trackObj};
			var me = this;      		
			new HawkEye(output).post();
		}catch(e){
			console.log("Error in Tracking :::",e);
		}
	}


	getUser(){
		return this.UserStore;
	}
	
	initiateFreshChat(){
		let disabledSites = window.noFreshChatSchoolIds || [];
		if(disabledSites.length > 0){
			let schoolId = this.getUser().getSchoolId();
			
			if(schoolId > 0 && disabledSites.indexOf(schoolId) > -1){
				return;
			}
		}

		HmEventRegistry.fireEvent("INIT_FRESHCHAT");		
	}

	render() {
		return(<div> {this.showLoader()} </div>)
	}
}



// WEBPACK FOOTER //
// ./src/views/core/LoggedInPage.js